import React from "react";
import { Flex, FormControl, FormLabel, Input, Button, ButtonGroup } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GOLD_BORDER, GOLD_TEXT } from "constants/brandColors";

const fieldProps = {
  bg: "white",
  borderColor: GOLD_BORDER,
  focusBorderColor: GOLD_BORDER,
};

const PRESETS = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
  { value: "all", label: "All" },
];

// Day/Week/Month are presets: picking one sets both the trend-chart bucket
// size AND a matching auto-computed date range (see computeRangeForInterval
// in index.jsx) — the From/To inputs go read-only since they're derived,
// not user-owned, in that mode. Custom just frees up From/To for manual
// entry; the bucket size stays fixed at "day" underneath (set by
// selectCustom in index.jsx) rather than exposing a separate control.
// "All" spans everything, so the fixed start date behind it is hidden rather
// than shown as a meaningless 01/01/2000.
export default function ReportFilters({
  interval,
  isCustomRange,
  from,
  to,
  onSelectPreset,
  onSelectCustom,
  onFromChange,
  onToChange,
  onReset,
}) {
  const { t } = useTranslation();
  const isAllTime = !isCustomRange && interval === "all";

  return (
    <Flex gap={4} wrap="wrap" align="flex-end">
      <FormControl w="auto">
        <FormLabel fontSize="sm" mb={1}>{t("Range")}</FormLabel>
        <ButtonGroup isAttached size="md">
          {PRESETS.map((preset) => (
            <Button
              key={preset.value}
              onClick={() => onSelectPreset(preset.value)}
              variant={!isCustomRange && interval === preset.value ? "solid" : "outline"}
              bg={!isCustomRange && interval === preset.value ? GOLD_BORDER : "white"}
              color={!isCustomRange && interval === preset.value ? "white" : GOLD_TEXT}
              borderColor={GOLD_BORDER}
              _hover={{ bg: GOLD_BORDER, color: "white" }}
            >
              {t(preset.label)}
            </Button>
          ))}
          <Button
            onClick={onSelectCustom}
            variant={isCustomRange ? "solid" : "outline"}
            bg={isCustomRange ? GOLD_BORDER : "white"}
            color={isCustomRange ? "white" : GOLD_TEXT}
            borderColor={GOLD_BORDER}
            _hover={{ bg: GOLD_BORDER, color: "white" }}
          >
            {t("Custom")}
          </Button>
        </ButtonGroup>
      </FormControl>

      <FormControl w="auto">
        <FormLabel fontSize="sm" mb={1}>{t("From")}</FormLabel>
        <Input
          type="date"
          value={isAllTime ? "" : from}
          isDisabled={!isCustomRange}
          onChange={(e) => onFromChange(e.target.value)}
          {...fieldProps}
        />
      </FormControl>
      <FormControl w="auto">
        <FormLabel fontSize="sm" mb={1}>{t("To")}</FormLabel>
        <Input
          type="date"
          value={to}
          isDisabled={!isCustomRange}
          onChange={(e) => onToChange(e.target.value)}
          {...fieldProps}
        />
      </FormControl>

      <Button onClick={onReset} variant="outline" borderColor={GOLD_BORDER} color={GOLD_TEXT} _hover={{ bg: GOLD_BORDER, color: "white" }}>
        {t("Reset")}
      </Button>
    </Flex>
  );
}
